module.exports = __webpack_public_path__ + "static/media/Swapping.8774d207.png";